export const STORAGE_KEY = "__tenantId__";

export const getStorageTenantId = () => window.localStorage.getItem(STORAGE_KEY) ?? null;
